module.exports = __webpack_public_path__ + "img/icon_agent_tr.ff2e094c.png";